import * as msgpack from '@mta/msgpack-js-lib';

export default class Application {
	constructor(
			/** ?int= */ id = null,
			/** ?string= */ name = '',
			/** ?string= */ description = '',
			/** ?string= */ contactEmails = '',
			/** !boolean= */ isRestricted = false,
			/** ?string= */ clientId = '',
			/** ?string= */ clientSecret = '',
			/** ?string= */ callbackUrl = '',
			/** ?string= */ applicationUrl = ''
	) {
		/** @member {?int} */
		this.id = id;
		/** @member {?string} */
		this.name = name;
		/** @member {?string} */
		this.description = description;
		/** @member {?string} */
		this.contactEmails = contactEmails;
		/** @member {!boolean} */
		this.isRestricted = isRestricted;
		/** @member {?string} */
		this.clientId = clientId;
		/** @member {?string} */
		this.clientSecret = clientSecret;
		/** @member {?string} */
		this.callbackUrl = callbackUrl;
		/** @member {?string} */
		this.applicationUrl = applicationUrl;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			id: os.writeNullableInt(this.id),
			name: os.writeString(this.name),
			description: os.writeString(this.description),
			contactEmails: os.writeString(this.contactEmails),
			isRestricted: os.writeBoolean(this.isRestricted),
			clientId: os.writeString(this.clientId),
			clientSecret: os.writeString(this.clientSecret),
			callbackUrl: os.writeString(this.callbackUrl),
			applicationUrl: os.writeString(this.applicationUrl)
		};
	}

	/**
	 * @param {!object} is
	 * @param {Application} value
	 */
	unpack(is, value) {
		if (value.id !== undefined)
			this.id = is.readNullableLong(value.id);
		if (value.name !== undefined)
			this.name = is.readString(value.name);
		if (value.description !== undefined)
			this.description = is.readString(value.description);
		if (value.contactEmails !== undefined)
			this.contactEmails = is.readString(value.contactEmails);
		if (value.isRestricted !== undefined)
			this.isRestricted = is.readBoolean(value.isRestricted);
		if (value.clientId !== undefined)
			this.clientId = is.readString(value.clientId);
		if (value.clientSecret !== undefined)
			this.clientSecret = is.readString(value.clientSecret);
		if (value.callbackUrl !== undefined)
			this.callbackUrl = is.readString(value.callbackUrl);
		if (value.applicationUrl !== undefined)
			this.applicationUrl = is.readString(value.applicationUrl);
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.application.Application', Application);
